import { useState } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";

function PageIdSelect(props) {
  const { workspaceId, onSubmit, onCancel, pageIds } = props;
  const inputField = {
    identifier: "",
  };
  const [loading, setLoading] = useState(false);
  const template = [
    {
      name: "identifier",
      label: "Page ID",
      type: "select",
      options: ["(None selected)", ...pageIds].map((pageId, idx) => {
        return {
          id: idx,
          value: pageId,
          label: pageId,
        };
      }),
    },
  ];
  const schema = {
    identifier: Joi.string().required(),
  };

  return (
    <Form
      inputField={inputField}
      template={template}
      schema={schema}
      loading={loading}
      setLoading={setLoading}
      buttonInfo={{
        buttons: "2",
        primaryLabel: "Add",
        secondaryLabel: "Cancel",
      }}
      onSubmit={onSubmit}
      handleSecondary={onCancel}
    />
  );
}

export { PageIdSelect}